// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__NqS0m","modal":"styles_modal__5D1PS","title":"styles_title__T6VSK","body":"styles_body__4c5Zo","footer":"styles_footer__wMozj"};